<template>
  <card-item
    card="item_dealer"
    :tabs="tabs"
    v-model="activeTab"
    :id="`${id}${$store.state.user.sections['dealers'] ? '' : '000030003'}`"
  >
  </card-item>
</template>
<script>
export default {
  methods: {},
  props: ["id"],
  data() {
    return {
      tabs: [
        {
          title: "Информация",
          key: "info",
          component: () => import("./Info"),
        },
        {
          title: "Заявки в банк",
          key: "loan",
          component: () => import("./Loans"),
        },
        {
          title: "Отчеты по месяцам",
          key: "loan",
          component: () => import("./Reports"),
        },
      ],
      activeTab: 0,
    };
  },
};
</script>